import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  differenceInMinutes,
  differenceInHours,
  differenceInDays
} from 'date-fns';

import getFormattedTime from '../../../../../../_shared/utils/getFormattedTime';

/**
 * Generates relative time string
 */
const getRelativeTime = datetime => {
  const now = new Date();
  const bidTime = new Date(datetime);
  const bidPlacedDaysAgo = differenceInDays(now, bidTime);
  const bidPlacedHoursAgo = differenceInHours(now, bidTime);
  const bidPlacedMinutesAgo = differenceInMinutes(now, bidTime);

  switch (true) {
    case bidPlacedDaysAgo > 0:
      return (
        <FormattedMessage
          id="vdp.bid.placedDaysAgo"
          values={{ daysAgo: bidPlacedDaysAgo }}
        />
      );
    case bidPlacedHoursAgo > 0:
      return (
        <FormattedMessage
          id="vdp.bid.placedHoursAgo"
          values={{ hoursAgo: bidPlacedHoursAgo }}
        />
      );
    case bidPlacedMinutesAgo > 0:
      return (
        <FormattedMessage
          id="vdp.bid.placedMinutesAgo"
          values={{ minsAgo: bidPlacedMinutesAgo }}
        />
      );
    default:
      return <FormattedMessage id="vdp.bid.under1Min" />;
  }
};

/**
 * Custom output of the bidder's name
 */
const FormattedBidTime = ({ bid, user }) => {
  const relativeTime = getRelativeTime(bid.dateCreated);

  if (user?.id === bid?.userId) {
    return (
      <b>
        {/* Your bid */}
        <FormattedMessage id="vdp.bid.yourBid" />
        &nbsp;&nbsp;
        {relativeTime}
      </b>
    );
  }

  return <>{relativeTime}</>;
};

/**
 * Formats time for state updates
 */
const FormattedAuctionTime = ({ startTime, userLocale }) => {
  if (!startTime) {
    return null;
  }

  return <>{getFormattedTime(startTime, userLocale)}</>;
};

export { FormattedBidTime, FormattedAuctionTime };
